import { StyleSheet, View } from 'react-native';

import {
  Button,
  IconClose,
  IconInfoFill,
  IconOffer,
  Text,
  XStack,
  YStack,
  tokens,
} from '@fhs/ui';

interface RewardNotAppliedAlertProps {
  title: string;
  subtitle?: string;
  message: string;
  onRemove?: () => void;
  testID?: string;
}

export function RewardNotAppliedAlert({
  title,
  subtitle,
  message,
  onRemove,
  testID,
}: RewardNotAppliedAlertProps) {
  return (
    <View testID={testID} style={styles.container} accessibilityRole="alert">
      <XStack style={styles.headerRow}>
        <XStack style={styles.titleRow}>
          <View style={styles.leftIconContainer}>
            <IconOffer size={20} color={tokens.colors.$white} />
          </View>
          <YStack style={styles.titleText}>
            <Text.Ui size="lg" weight="semibold">
              {title}
            </Text.Ui>
            {!!subtitle && (
              <Text.Paragraph size="md" style={styles.subtitle}>
                {subtitle}
              </Text.Paragraph>
            )}
          </YStack>
        </XStack>
        {onRemove && (
          <Button
            type="outline-subtle"
            onPress={onRemove}
            accessibilityRole="button"
            accessibilityLabel="Remove reward"
          >
            <Button.Icon size={16}>
              <IconClose />
            </Button.Icon>
            <Button.Text>Remove</Button.Text>
          </Button>
        )}
      </XStack>

      <XStack style={styles.messageRow}>
        <IconInfoFill size={16} color={tokens.colors.$houseDark} />
        <Text style={styles.messageText}>{message}</Text>
      </XStack>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: tokens.colors.$errorBackground,
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderRadius: 8,
  },
  headerRow: {
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  titleRow: {
    gap: 8,
    flex: 1,
  },
  titleText: {
    gap: 2,
    flex: 1,
  },
  leftIconContainer: {
    height: 37,
    width: 37,
    borderRadius: 50,
    backgroundColor: tokens.colors.$error,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 2,
  },
  subtitle: {
    marginTop: -2,
    color: tokens.colors.$blackOpacity55,
    fontWeight: '400',
  },
  messageRow: {
    alignItems: 'center',
    gap: 8,
    marginTop: 30,
  },
  messageText: {
    fontSize: 12,
    lineHeight: 16.8,
    color: tokens.colors.$houseDark,
    flex: 1,
  },
});
